const moment = require("moment-timezone");

var AbstractViewModel = require("./AbstractViewModel")
var createLargeListViewAppointmentsWS = require("../ws/LargeListViewAppointmentsWS").createLargeListViewAppointmentsWS
var RecentArrivalsWS = require("../ws/RecentArrivalsWS")
var flatMap = require("../helpers/operators").flatMap
var findInArrays = require("../helpers/polyfill").findInArrays

function ListViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  self.view = ko.observable('all');

  // Configuration
  self.sortListViewBySummonable = false;

  // Temporal settings
  var today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  today.setMilliseconds(0);

  self.appointmentListSelectedDate = ko.observable(today.toISOString().split('T')[0]);

  self.arrivedSortCol = ko.observable(null);
  self.arrivedSortDir = ko.observable('ASC');
  self.expiredSortCol = ko.observable(null);
  self.expiredSortDir = ko.observable('ASC');
  self.summonedSortCol = ko.observable(null);
  self.summonedSortDir = ko.observable('ASC');
  self.waitingSortCol = ko.observable(null);
  self.waitingSortDir = ko.observable('ASC');


  // Supporting services
  self.listViewAppointmentsWS = createLargeListViewAppointmentsWS(self, moment);
  self.listViewRecentArrivalsWS = new RecentArrivalsWS(self);


  /**
   * Determines if any of the spots have the requested field with values
   *
   * @method hasFieldValues
   * @param {String} val
   * @returns {Boolean}
   */
  self.hasFieldValues = function (spots, val) {
    return spots.filter(function (spot) {
      return (typeof spot[val] === 'function') ? spot[val]() : spot[val];
    }).length > 0;
  };


  self.getSpotsCustomProps = function(spots) {
    return ko.pureComputed(function() {
      return spots().reduce(function (customPropNames, spot) {

        if (spot.customProps) {
          return customPropNames.concat(spot.customProps.map(function(customProp) {
            return customProp.name;
          }));
        }

        return customPropNames;
      }, []).unique();
    });
  }


	/**
	 * Returns a collection of SpotModels that are waiting to be serviced
	 * Will also sort returns
	 *
	 * @method waitingSpots
	 * @returns {Array}
	 */
  self.waitingSpots = ko.pureComputed(function () {
    var col = self.waitingSortCol();
    var dir = self.waitingSortDir();
    var spots = flatMap(self.parent.queuesWS.queues(), function(queue) {
      return queue.spots();
    });

    if (col) {
      spots.sort(self.dynamicSort(col, dir));
    }

    return spots;
  });


  self.waitingSpotsCustomProps = self.getSpotsCustomProps(self.waitingSpots)


	/**
	 * Returns a collection of SpotModels that have been summoned to be
   * served but who failed to arrive. Will also sort returns
	 *
	 * @method expiredSpots
	 * @returns {Array}
	 */
  self.expiredSpots = ko.computed(function () {
    var col = self.expiredSortCol();
    var dir = self.expiredSortDir();
    var spots = flatMap(self.parent.queuesWS.queues(), function(queue) {
      return queue.expiredTickets();
    });

    if (col) {
      spots.sort(self.dynamicSort(col, dir));
    }

    return spots;
  });


  self.expiredSpotsCustomProps = self.getSpotsCustomProps(self.expiredSpots)


	/**
	 * Returns a collection of SpotModels that have been summoned to be served
	 * Will also sort returns
	 *
	 * @method summonedSpots
	 * @returns {Array}
	 */
  self.summonedSpots = ko.computed(function () {
    var col = self.summonedSortCol();
    var dir = self.summonedSortDir();
    var spots = flatMap(self.parent.queuesWS.queues(), function(queue) {
      return queue.tickets();
    });

    if (col) {
      spots.sort(self.dynamicSort(col, dir));
    }

    return spots;
  });


  self.summonedSpotsCustomProps = self.getSpotsCustomProps(self.summonedSpots);


  /**
   * Returns the appointment time for the specified appointment
   *
   * @method appointmentTime
   * @param {Object} appt
   * @returns {String | Null}
   */
  self.appointmentTime = function (appt) {
    if (appt) {
      var time = new Date(Date.parse(appt.start));
      return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    return null;
  };


	/**
	 * Returns a class name corresponding to the column name provided
	 *
	 * @method arrivedColSorted
	 * @param {String} colName
	 * @returns {String}
	 */
  self.arrivedColSorted = function (colName) {
    var c = self.arrivedSortCol();
    var d = self.arrivedSortDir().toLowerCase();
    return (c === colName) ? 'sorted-' + d : '';
  };


	/**
	 * Returns a collection of data reflecting customers summoned and marked as
   * arrived. Will also sort returns
	 *
	 * @method arrivedSpots
	 * @returns {Array}
	 */
  self.arrivedSpots = ko.computed(function () {
    var col = self.arrivedSortCol();
    var dir = self.arrivedSortDir();
    var spots = self.listViewRecentArrivalsWS.spots();

    if (col) {
      spots.sort(self.dynamicSort(col, dir));
    }

    return spots;
  });


	/**
	 * Determines if the list view can be shown. Must be enabled for at least
   * one of the selected locations and the user must be a queueAdmin or the
   * location not restrict list view to queueAdmins
	 *
	 * @method canShow
	 * @returns {Boolean}
	 */
  self.canShow = ko.computed(function () {
    var locs = self.parent.selectedLocations() || [];

    return locs.filter(function (loc) {
      return loc.listViewEnabled && (!loc.limitListViewToQueueAdminRole || self.parent.hasRole('queueAdmin.location.' + loc.id));
    }).length > 0;
  }, self, { deferEvaluation: true });


	/**
	 * Hones the view down to a specific subset of data
	 *
	 * @method changeView
	 * @param {Data} data
	 * @param {MouseEvent} evt
	 * @returns {Boolean} true
	 */
  self.changeView = function (data, evt) {
    var el = evt.target;
    var v = el.getAttribute('data-view');

    // Only bother to change view if the button clicked was not already selected AND not disabled
    if (el.getAttribute('class') === 'btn') {
      self.view(v);
    }
  };


	/**
	 * Method to return a closured function in order to sort objects based
   * on a property
	 *
	 * @method dynamicSort
	 * @param {String} property
	 * @param {String} dir
	 * @returns {Number}
	 */
  self.dynamicSort = function (property, direction) {
    if (!direction){
      direction = 'ASC';
    }

    var comparisonFns = {
      'ASC': self.compareAscending,
      'DESC': self.compareDescending
    }

    return comparisonFns[direction](property);
  };

  self.compareDescending = function(property) {
    return function (left, right) {
      var isFn = typeof left[property] === "function";
      var l = (isFn) ? left[property]() : left[property];
      var r = (isFn) ? right[property]() : right[property];

      if (l > r || !r) {
        return -1;
      }

      if ((l === r) || (!l && !r)) {
        return 0;
      }

      if (l < r || !l) {
        return 1;
      }
    }
  }

  self.compareAscending = function(property) {
    return function (left, right) {

      var isFn = typeof left[property] === "function";
      var l = (isFn) ? left[property]() : left[property];
      var r = (isFn) ? right[property]() : right[property];

      if (l < r || !r) {
        return -1;
      }

      if ((l === r) || (!l && !r)) {
        return 0;
      }

      if (l > r || !l) {
        return 1;
      }
    }
  }


	/**
	 * Returns a class name corresponding to the column name provided
	 *
	 * @method expiredColSorted
	 * @param {String} colName
	 * @returns {String}
	 */
  self.expiredColSorted = function (colName) {
    var c = self.expiredSortCol();
    var d = self.expiredSortDir().toLowerCase();
    return (c === colName) ? 'sorted-' + d : '';
  };


	/**
	 * Returns a concatenated string that apparently doesn't exist in
   * QueueManager
	 *
	 * @method expiredTitle
	 * @returns {String}
	 */
  self.expiredTitle = ko.computed(function () {
    // Creates a hook to fire once the message bundle has loaded/changed
    var msg = self.parent.messagesWS;
    var bndl = msg.bundle(); // Computed observable hook
    var exp = msg.get('expired');

    return exp.charAt(0).toUpperCase() + exp.slice(1) + ' ' + msg.get('customers.cap');
  },  self, { deferEvaluation: true });


	/**
	 * Resets the add consumer interface to a default state
	 *
	 * @method reset
	 * @returns none
	 */
  self.reset = function (iQueueId) {
  };


	/**
	 * Determines if call ahead is available
	 *
	 * @method setCallAheadForLocation
	 * @returns {Boolean}
	 */
  self.setCallAheadForLocation = ko.computed(function () {
    return self.parent.callAheadSupported(true);
  }, self, { deferEvaluation: true });


	/**
	 * Methods to be run once the interface is requested to be presented
   * to the user
	 *
	 * @method show
	 * @returns none
	 */
  self.show = function () {
    self.update();
  };


	/**
	 * Determines whether the appointment start column should be presented
	 *
	 * @method showAppointmentStart
	 * @returns {Boolean}
	 */
  self.showAppointmentStart = ko.computed(function () {
    var queues = self.parent.appointmentQueues();

    // Also control the visibility with the presence of any relevant data
    var spots = self.waitingSpots().filter(function (s) {
      return s.appointmentTime();
    });

    return queues.length > 0 && spots.length > 0;
  }, self, { deferEvaluation: true });


	/**
	 * Determines whether the call ahead column should be presented
	 *
	 * @method showCallAhead
	 * @returns {Boolean}
	 */
  self.showCallAhead = ko.computed(function () {
    return self.parent.callAheadSupported() && self.parent.messagesWS.get('hideCallAheadColumnInListView') !== true;
  }, self, { deferEvaluation: true });

  /**
   * Returns true if the date selected in the appointment date picker is same or equal current date.
   *
   * @method allowBeginService
   * @returns {Boolean} 
   */
   self.allowBeginService = function(currentDate, status) {
    var selectedDate = self.appointmentListSelectedDate();

    return currentDate.isSameOrAfter(selectedDate) && 
      self.parent.allowBeginService() && 
      (['SERVED_EARLY', 'QUEUED'].indexOf(status) == -1) ;
  }

  self.allowBeginServiceToday = function (status) {
    var today = moment();
    return self.allowBeginService(today, status);
  }

	/**
	 * Determines whether the location column should be presented
	 *
	 * @method showLocationCol
	 * @returns {Boolean}
	 */
  self.showLocationCol = ko.computed(function () {
    var locs = self.parent.selectedLocationIds();

    return locs && locs.length > 1;
  }, self, { deferEvaluation: true });


	/**
	 * Determines whether the party size column should be displayed based
   * on whether any of the selected locations use party size
	 *
	 * @method showPartySize
	 * @returns {Boolean}
	 */
  self.showPartySize = ko.computed(function () {
    var locs = self.parent.selectedLocations() || [];

    return locs.filter(function (loc) {
      return loc.usePartySize;
    }).length > 0;
  }, self, { deferEvaluation: true });


	/**
	 * Determines whether the classifiers column should be displayed based
   * on whether any of the selected locations have ticket classifiers
	 *
	 * @method showTicketClassifiers
	 * @returns {Boolean}
	 */
  self.showTicketClassifiers = ko.computed(function () {
    var locs = self.parent.selectedLocations() || [];

    return locs.filter(function (loc) {
      return loc.ticketClassifiers.length > 0;
    }).length > 0;
  }, self, { deferEvaluation: true });


	/**
	 * Method to receive click in UI
	 * Parses data-col attribute to determine which col is currently sorted
	 *
	 * @method sortArrived
	 * @param {Data} data
	 * @param {MouseEvent} evt
	 * @returns {Boolean} true
	 */
  self.sortArrived = function (data, evt) {

    var col = evt.currentTarget.getAttribute('data-col');

    if (col) {
      if (self.arrivedSortCol() === col) {
        self.arrivedSortDir(self.arrivedSortDir() === 'ASC' ? 'DESC' : 'ASC');
      }
      else {
        self.arrivedSortDir('ASC');
      }

      self.arrivedSortCol(col);
    }

    return true;
  };


	/**
	 * Method to receive click in UI
	 * Parses data-col attribute to determine which col is currently sorted
	 *
	 * @method sortExpired
	 * @param {Data} data
	 * @param {MouseEvent} evt
	 * @returns {Boolean} true
	 */
  self.sortExpired = function (data, evt) {
    var col = evt.currentTarget.getAttribute('data-col');

    if (col) {
      if (self.expiredSortCol() === col) {
        self.expiredSortDir(self.expiredSortDir() === 'ASC' ? 'DESC' : 'ASC');
      }
      else {
        self.expiredSortDir('ASC');
      }

      self.expiredSortCol(col);
    }

    return true;
  };


	/**
	 * Method to receive click in UI
	 * Parses data-col attribute to determine which col is currently sorted
	 *
	 * @method sortSummoned
	 * @param {Data} data
	 * @param {MouseEvent} evt
	 * @returns {Boolean} true
	 */
  self.sortSummoned = function (data, evt) {
    var col = evt.currentTarget.getAttribute('data-col');

    if (col) {
      if (self.summonedSortCol() === col) {
        self.summonedSortDir(self.summonedSortDir() === 'ASC' ? 'DESC' : 'ASC');
      }
      else {
        self.summonedSortDir('ASC');
      }

      self.summonedSortCol(col);
    }

    return true;
  };


	/**
	 * Method to receive click in UI
	 * Parses data-col attribute to determine which col is currently sorted
	 *
	 * @method sortWaiting
	 * @param {Data} data
	 * @param {MouseEvent} evt
	 * @returns {Boolean} true
	 */
  self.sortWaiting = function (data, evt) {
    var col = evt.currentTarget.getAttribute('data-col');

    if (col) {
      // Toggle the Sort Direction when clicking on the same column
      if (self.waitingSortCol() === col) {
        self.waitingSortDir(self.waitingSortDir() === 'ASC' ? 'DESC' : 'ASC');
      }
      else {
        self.waitingSortDir('ASC');
      }

      self.waitingSortCol(col);
    }

    return true;
  };


	/**
	 * Returns a class name corresponding to the column name provided
	 *
	 * @method summonColSorted
	 * @param {String} colName
	 * @returns {String}
	 */
  self.summonColSorted = function (colName) {
    var c = self.summonedSortCol();
    var d = self.summonedSortDir().toLowerCase();
    return (c === colName) ? 'sorted-' + d : '';
  };


	/**
	 * Returns a trimmed string, because the message has a token
	 *
	 * @method summonedByTitle
	 * @returns {String}
	 */
  self.summonedByTitle = ko.computed(function () {
    var bndle = self.parent.messagesWS.bundle(); // Computed Observable Hook
    var msg = self.parent.messagesWS.get('summoned.by');

    return msg.substr(0, msg.length - 4);
  }, self, { deferEvaluation: true });


	/**
	 * Requests fresh data from the API
	 *
	 * @method update
	 * @returns none
	 */
  self.update = function () {
    // Only grab API data if the view is currently visible
    if (self.parent.showListView()) {
      self.showAppointmentsToday();
      self.listViewRecentArrivalsWS.doRequest();
    }
  };


	/**
	 * Visibility Controller
	 *
	 * @method showAppointments
	 * @returns {Boolean}
	 */
  self.showAppointments = ko.computed(function () {
    return (self.view() === 'all' || self.view() === 'appointments') && self.parent.appointmentQueues().length > 0;
  }, self, { deferEvaluation: true });


	/**
	 * Visibility Controller
	 *
	 * @method showArrived
	 * @returns {Boolean}
	 */
  self.showArrived = ko.computed(function () {
    return (self.view() === 'all' || self.view() === 'arrived') && self.arrivedSpots().length > 0
  }, self, { deferEvaluation: true });


	/**
	 * Visibility Controller
	 *
	 * @method showWaiting
	 * @returns {Boolean}
	 */
  self.showWaiting = ko.computed(function () {
    return (self.view() === 'all' || self.view() === 'waiting') && self.waitingSpots().length > 0
  }, self, { deferEvaluation: true });


	/**
	 * Visibility Controller
	 *
	 * @method showExpired
	 * @returns {Boolean}
	 */
  self.showExpired = ko.computed(function () {
    return (self.view() === 'all' || self.view() === 'expired') && self.expiredSpots().length > 0
  }, self, { deferEvaluation: true });


	/**
	 * Visibility Controller
	 *
	 * @method showSummoned
	 * @returns {Boolean}
	 */
  self.showSummoned = ko.computed(function () {
    return (self.view() === 'all' || self.view() === 'summoned') && self.summonedSpots().length > 0
  }, self, { deferEvaluation: true });


	/**
	 * Method to make sure that the view changes when data it supports disappears
	 *
	 * @method checkCurrentView
	 * @returns none
	 */
  self.checkCurrentView = function () {
    var bChangeToAll = false;

    if (self.view() === 'arrived' && !self.showArrived()) {
      bChangeToAll = true;
    }
    else if (self.view() === 'waiting' && !self.showWaiting()) {
      bChangeToAll = true;
    }
    else if (self.view() === 'expired' && !self.showExpired()) {
      bChangeToAll = true;
    }
    else if (self.view() === 'summoned' && !self.showSummoned()) {
      bChangeToAll = true;
    }

    if (bChangeToAll) {
      self.view('all');
    }
  };


	/**
	 * Subscription to watch when the appointments change and to invoke the
   * view change if necessary
	 *
	 * @method listViewAppointmentsWS.spots.subscribe
	 * @returns none
	 */
  self.listViewAppointmentsWS.appointments.subscribe(function () {
    setTimeout(self.checkCurrentView, 500);
  });


	/**
	 * Subscription to watch when the spots change and to invoke the view
   * change if necessary
	 *
	 * @method listViewRecentArrivalsWS.spots.subscribe
	 * @returns none
	 */
  self.listViewRecentArrivalsWS.spots.subscribe(function () {
    setTimeout(self.checkCurrentView, 500);
  });



	/**
	 * Returns a class name corresponding to the column name provided
	 *
	 * @method waitColSorted
	 * @param {String} colName
	 * @returns {String}
	 */
  self.waitColSorted = function (colName) {
    var c = self.waitingSortCol();
    var d = self.waitingSortDir().toLowerCase();
    return (c === colName) ? 'sorted-' + d : '';
  };

  /**
   * Returns the displayed date for the appointment list.
   *
   * @method displayedAppointmentDate
   * @returns {String}
   */
  self.displayedAppointmentDate = ko.computed(function() {
    if (moment && moment.locale) {
      // Transforms POSIX locale `fr_CA` to the format used by Moment `fr-ca`
      var localeCode = self.parent.userLang()
        .replace('_', '-')
        .toLowerCase()
      moment.locale(localeCode)
      var displayedDate = moment(self.appointmentListSelectedDate()).format('dddd, MMMM D, YYYY');
      // Revert the locale after we have saved the transformed date format
      // to prevent weirdness with date formats in 'ar'
      moment.locale('en');
      return displayedDate
    }
  }, self, { deferEvaluation: true })

  /**
   * Returns true if the date selected in the appointment date picker is the current date.
   *
   * @method todayIsSelectedDate
   * @returns {Boolean}
   */
  self.todayIsSelectedDate = ko.computed(function() {
    var today = moment().format('YYYY-MM-DD');
    return self.appointmentListSelectedDate() === today ? true : false;
  }, self, { deferEvaluation: true })

  /**
   * Resets the appointment list to the current date
   *
   * @method showAppointmentsToday
   * @returns none
   */
  self.showAppointmentsToday = function() {
    moment.locale('en')
    var today = moment();
    var start = today.format('YYYY-MM-DD');
    var end = today.add(1, "days").format('YYYY-MM-DD');
    self.appointmentListSelectedDate(start);
    self.listViewAppointmentsWS.doRequest(null, { start: start, end: end });
  }

  /**
   * Generates a link to print the currently displayed appointments
   *
   * @method appointmentsPrintUrl
   * @returns {String}
   */
  self.appointmentsPrintUrl = function() {
    moment.locale('en')
    var timeZone = moment.tz.guess();
    var rangeStart = moment(self.appointmentListSelectedDate()).format('YYYY-MM-DD') + 'T00:00:00.0-08:00';
    var rangeEnd = moment(rangeStart).add(1, 'days').format('YYYY-MM-DD');
    var lang = self.parent.userLang();

    var appointmentPrintListURL = "/qless/merchant/printAppointments/?";
    if (self.parent.appointmentQueues()) {
      appointmentPrintListURL += "queueIds="
      var apptQueueIds = self.parent.appointmentQueues().map(function(queue) {
        return queue.id
      });
      appointmentPrintListURL += apptQueueIds.map( function (queueId) { return queueId }).join(',')
    }

    if (self.parent.selectedLocationIds()) {
      appointmentPrintListURL += "&locationIds="
      appointmentPrintListURL += self.parent.selectedLocationIds().map(function(locationId) { return locationId }).join(',');
    }

    appointmentPrintListURL += "&start=" + rangeStart + "&end=" + rangeEnd + '&timeZone=' + timeZone + "&locale=" + lang;
    return appointmentPrintListURL;
  }

  /**
   * Opens a new tab so the user can print the currently displayed appointments
   *
   * @method printDisplayedAppointments
   * @returns none
   */
  self.printDisplayedAppointments = function() {
    window.open(self.appointmentsPrintUrl(), '_blank');
  }

  /**
   * Increments the current date range to view the next days appointments
   *
   * @method nextAppointmentsDate
   * @returns none
   */
  self.nextAppointmentsDate = function() {
    var nextAppointmentDate = moment(self.appointmentListSelectedDate()).add(1, 'days')
      .format('YYYY-MM-DD');
    var dayAfterAppointmentDate = moment(self.appointmentListSelectedDate()).add(2, 'days')
      .format('YYYY-MM-DD');
    self.showAppointmentsDuring(nextAppointmentDate, dayAfterAppointmentDate);
  }

  /**
   * Decrements the current date range to view the next days appointments
   *
   * @method previousAppointmentsDate
   * @returns none
   */
  self.previousAppointmentsDate = function() {
    var previousAppointmentDate = moment(self.appointmentListSelectedDate()).add(-1, 'days')
      .format('YYYY-MM-DD');
    var currentAppointmentDate = moment(self.appointmentListSelectedDate()).format('YYYY-MM-DD');
    self.showAppointmentsDuring(previousAppointmentDate, currentAppointmentDate);
  }

  /**
   * Updates the displayed appointments based on the date range provided.
   *
   * @method showAppointmentsDuring
   * @param {string} Start
   * @param {string} End
   * @returns none
   */
  self.showAppointmentsDuring = function(start, end) {
    var dateRange = {
      start: start,
      end: end
    }
    self.listViewAppointmentsWS.doRequest(null, dateRange);
    self.appointmentListSelectedDate(start);
  }


  /**
   * Dictate what action the appointment navigation controls do.
   *
   * @method appointmentDateAction
   * @param {String} direction
   * @returns {Function}
   */
  self.appointmentDateAction = function(direction) {
    if (direction === 'left') {
      return self.parent.isRTL() ? self.nextAppointmentsDate : self.previousAppointmentsDate;
    } else {
      return self.parent.isRTL() ? self.previousAppointmentsDate : self.nextAppointmentsDate;
    }
  }

  /**
   * @description Opens a new tab and displays the print view from the generated download URL
   * @method printConsumers
   * @param {String} method the API method to be called
   * @returns none
   */
  self.printConsumers = function(method) {
    window.open(self.consumerPrintURL(method));
  }

  /**
   * @description Generates the URL for printing the list of the selected type of Consumer Spots
   * @method expiredPrintURL
   * @param {string} method the API method to be called
   * @returns {string} the print URL
   */
  self.consumerPrintURL = function(method) {
    var queueIds = self.parent.queueIds();
    return '/qless/merchant/' + method + '/?queueIds=' + queueIds.join(',') + '&timeZone=' + moment.tz.guess();
  }

  // Expose the object as it's own API
  return self;
}

ListViewModel.prototype = AbstractViewModel.prototype;
ListViewModel.prototype.constructor = ListViewModel;

/**
 *
 * @param {string} sessionId the Session ID of the selected Consumer
 * @param {number} queueId the ID of the queue the selected Spot is in
 */
ListViewModel.prototype.getSpotBySessionId = function (sessionId, queueId) {
  var foundSpot = findInArrays(
    function (spot) {
      return (spot.sessionId == sessionId && spot.queueId == queueId);
    },
    [
      this.expiredSpots(),
      this.waitingSpots(),
      this.summonedSpots()
    ]
  );

  // If a Spot has not been found, return null to stay consistent with existing code.
  return foundSpot !== undefined ? foundSpot : null;
};


module.exports = ListViewModel;
